export default "__VITE_ASSET__DNzxlvBD__"